import { AppBar, Toolbar } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { styled } from "@mui/material";

export default function VideoPlayer(props) {
  const history = useHistory();

  const dados = props.location.state.dadosVideo;

  const altura = window.innerHeight - 80;
  const largura = window.innerWidth;

  return (
    <>
      <AppBar position="fixed">
        <Toolbar style={{ background: "black", color: "white" }}>
          <ArrowBackIcon
            onClick={() =>
              history.push({
                pathname: "unidade",
                state: { dadosUnidade: dados },
              })
            }
            style={{
              fontWeight: "bolder",
              color: "white",
              marginRight: 20,
              cursor: "pointer",
            }}
          />
          <h2>Perto Teachers - Video</h2>
        </Toolbar>
      </AppBar>

      <Main style={{ marginBottom: 60, marginTop: 60 }}>
        <div
          style={{
            // display: "flex",
            textAlign: "center",
            background: "black",
            color: "white",
          }}
        >
          <h2>
            {dados.titulo} - {dados.unidadeTitulo}
          </h2>
        </div>
        <iframe
          videoId="yMb14hJEgX8"
          width={largura}
          height={altura}
          // src=""
          // allow="autoplay"
          allowFullScreen
          src={`https://www.youtube.com/embed/${dados.referencia}?autoplay=1`}
          frameborder="0"
        ></iframe>
      </Main>
    </>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);
